import { Group } from '@app/shared/models/group';
import { Role } from '@app/shared/models/role';
import { User } from '@app/shared/models/user';
import { createAction, props } from '@ngrx/store';

// Groups
export const LoadGroups = createAction(
  '[TeamGroups] Load Groups',
  props<{ teamId: string }>()
);

export const LoadGroupsSuccess = createAction(
  '[TeamGroups] Load Groups Success',
  props<{ groups: Group[] }>()
);

export const LoadGroupsFailure = createAction(
  '[TeamGroups] Load Groups Failure',
  props<{ error: any }>()
);

// Roles
export const LoadAttributableRoles = createAction(
  '[TeamGroups] Load Attributable Roles',
  props<{ teamId: string }>()
);

export const LoadAttributableRolesSuccess = createAction(
  '[TeamGroups] Load Attributable Roles Success',
  props<{ roles: Role[] }>()
);

export const LoadAttributableRolesFailure = createAction(
  '[TeamGroups] Load Attributable Roles Failure',
  props<{ error: any }>()
);

// Group Details
export const LoadGroupDetails = createAction(
  '[TeamGroups] Load Group Details',
  props<{ teamId: string, id: string }>()
);

export const LoadGroupDetailsSuccess = createAction(
  '[TeamGroups] Load Group Details Success',
  props<{ group: Group }>()
);

export const LoadGroupDetailsFailure = createAction(
  '[TeamGroups] Load Group Details Failure',
  props<{ error: any }>()
);

// Group Roles
export const LoadGroupRoles = createAction(
  '[TeamGroups] Load Group Roles',
  props<{ teamId: string, id: string }>()
);

export const LoadGroupRolesSuccess = createAction(
  '[TeamGroups] Load Group Roles Success',
  props<{ roles: Role[] }>()
);

export const LoadGroupRolesFailure = createAction(
  '[TeamGroups] Load Group Roles Failure',
  props<{ error: any }>()
);

// Group Members
export const LoadGroupMembers = createAction(
  '[TeamGroups] Load Group Members',
  props<{ teamId: string, id: string }>()
);

export const LoadGroupMembersSuccess = createAction(
  '[TeamGroups] Load Group Members Success',
  props<{ members: User[] }>()
);

export const LoadGroupMembersFailure = createAction(
  '[TeamGroups] Load Group Members Failure',
  props<{ error: any }>()
);

// Account Members
export const LoadAccountMembers = createAction(
  '[TeamGroups] Load Account Members',
);

export const LoadAccountMembersSuccess = createAction(
  '[TeamGroups] Load Account Members Success',
  props<{ members: User[] }>()
);

export const LoadAccountMembersFailure = createAction(
  '[TeamGroups] Load Account Members Failure',
  props<{ error: any }>()
);

// Create group
export const CreateGroup = createAction(
  '[TeamGroups] Create Group',
  props<{ teamId: string, name: string }>()
);

export const CreateGroupSuccess = createAction(
  '[TeamGroups] Create Group Success',
  props<{ group: Group }>()
);

export const CreateGroupFailure = createAction(
  '[TeamGroups] Create Group Failure',
  props<{ error: any }>()
);

// Attach Member to group
export const AttachMemberToGroup = createAction(
  '[TeamGroups] Attach Member To Group',
  props<{ teamId: string, member: User, groupId: string }>()
);

export const AttachMemberToGroupSuccess = createAction(
  '[TeamGroups] Attach Member To Group Success'
);

export const AttachMemberToGroupFailure = createAction(
  '[TeamGroups] Attach Member To Group Failure',
  props<{ error: any }>()
);

// Attach Role to group
export const AttachRoleToGroup = createAction(
  '[TeamGroups] Attach Role To Group',
  props<{ teamId: string, groupId: string, role: any }>()
);

export const AttachRoleToGroupSuccess = createAction(
  '[TeamGroups] Attach Role To Group Success'
);

export const AttachRoleToGroupFailure = createAction(
  '[TeamGroups] Attach Role To Group Failure',
  props<{ error: any }>()
);

// Detach Role from group
export const DetachRoleFromGroup = createAction(
  '[TeamGroups] Detach Role From Group',
  props<{ teamId: string, groupId: string, role: any }>()
);

export const DetachRoleFromGroupSuccess = createAction(
  '[TeamGroups] Detach Role From Group Success'
);

export const DetachRoleFromGroupFailure = createAction(
  '[TeamGroups] Detach Role From Group Failure',
  props<{ error: any }>()
);

// Detach Member from group
export const DetachMemberFromGroup = createAction(
  '[TeamGroups] Detach Member From Group',
  props<{ teamId: string, userId: string, groupId: string }>()
);

export const DetachMemberFromGroupSuccess = createAction(
  '[TeamGroups] Detach Member From Group Success'
);

export const DetachMemberFromGroupFailure = createAction(
  '[TeamGroups] Detach Member From Group Failure',
  props<{ error: any }>()
);

// Update group
export const UpdateGroup = createAction(
  '[TeamGroups] Update Group',
  props<{ teamId: string, group: any }>()
);

export const UpdateGroupSuccess = createAction(
  '[TeamGroups] Update Group Success',
  props<{ group: Group }>()
);

export const UpdateGroupFailure = createAction(
  '[TeamGroups] Update Group Failure',
  props<{ error: any }>()
);

// Delete group
export const DeleteGroup = createAction(
  '[TeamGroups] Delete Group',
  props<{ teamId: string, groupId: string }>()
);

export const DeleteGroupSuccess = createAction(
  '[TeamGroups] Delete Group Success'
);

export const DeleteGroupFailure = createAction(
  '[TeamGroups] Delete Group Failure',
  props<{ error: any }>()
);